import { render, staticRenderFns } from "./messagePreviewDialog.vue?vue&type=template&id=6b62831a&"
import script from "./messagePreviewDialog.vue?vue&type=script&lang=js&"
export * from "./messagePreviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./messagePreviewDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b62831a')) {
      api.createRecord('6b62831a', component.options)
    } else {
      api.reload('6b62831a', component.options)
    }
    module.hot.accept("./messagePreviewDialog.vue?vue&type=template&id=6b62831a&", function () {
      api.rerender('6b62831a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/edi/messagePreviewDialog.vue"
export default component.exports